import {Routes} from '@angular/router';

export const rechargeCashRoutes: Routes = [
  {
    path: 'recharge.cash',
    loadComponent: () => import('./recharge.cash.component').then(m => m.RechargeCashComponent),
    data: {title: '充值返现兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '充值返现兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '充值返现兑付明细' },
      },
    ]
  },
]
